/**
 * Affiche un téléphone FR formaté en groupes de 2 (06 12 34 56 78).
 * Utilisé uniquement pour affichage, ne mute pas la valeur source.
 */
export function formatPhone(value) {
  if (!value) return '';
  const digits = String(value).replace(/\D/g, '');
  if (digits.length === 0) return '';
  // +33 X XX XX XX XX
  if (digits.length === 11 && digits.startsWith('33')) {
    return '+33 ' + digits.slice(2).match(/.{1,2}/g).join(' ');
  }
  // 0X XX XX XX XX
  if (digits.length === 10 && digits.startsWith('0')) {
    return digits.match(/.{1,2}/g).join(' ');
  }
  return value;
}

export function validateEmail(email) {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
}

export function subscriptionStatusLabel(status) {
  if (!status) return 'Aucun abonnement';
  switch (status) {
    case 'active': return 'Actif';
    case 'past_due': return 'Impayé';
    case 'cancelled':
    case 'canceled': return 'Annulé';
    case 'incomplete':
    case 'incomplete_expired': return 'En attente';
    case 'trialing': return 'Essai en cours';
    case 'paused': return 'En pause';
    case 'unpaid': return 'Non payé';
    default: return String(status);
  }
}

export function subscriptionStatusColor(status) {
  if (!status) return 'default';
  if (status === 'active' || status === 'trialing') return 'success';
  if (status === 'past_due' || status === 'unpaid') return 'warning';
  if (status === 'cancelled' || status === 'canceled') return 'danger';
  return 'default';
}

// ⚠️ Vue mobile (app iOS/Android) — libellés FR en dur, non i18n à ce stade.
// 'essentiel' est LEGACY (69 €, plus vendu depuis le 30/07/2026) : on le
// conserve tel quel pour qu'un abonné d'avant cette date voie toujours son
// plan correctement dans l'onglet Profil.
const PLAN_FEATURES = {
  decouverte: [
    'QR code + page de capture',
    'Retours privés',
    'Tableau de bord & suivi de note',
    '1 établissement',
  ],
  essentiel: [
    '200 SMS / mois',
    '1 établissement',
    'QR code + funnel',
    'Insights IA',
  ],
  pro: [
    '500 SMS / mois',
    '1 établissement ambitieux',
    'QR code + funnel',
    'Insights IA',
    'Réponses IA aux avis',
  ],
  intensif: [
    'SMS illimités',
    'Multi-établissements',
    'QR code + funnel',
    'Insights IA',
    'Réponses IA aux avis',
    'Support prioritaire',
  ],
};

export function planMeta(planId) {
  const id = (planId || '').toLowerCase();
  switch (id) {
    case 'decouverte':
      return { id: 'decouverte', name: 'Découverte', price: 9.99, features: PLAN_FEATURES.decouverte };
    // 'starter' = alias historique d'Essentiel : c'est la valeur réellement
    // présente en base pour les abonnés existants. Sans ce case, l'onglet
    // Profil afficherait « Aucun abonnement actif » à un client payant.
    case 'essentiel':
    case 'starter':
      return { id: 'essentiel', name: 'Essentiel', price: 69, features: PLAN_FEATURES.essentiel };
    case 'pro':
      return { id: 'pro', name: 'Pro', price: 89, features: PLAN_FEATURES.pro, highlight: true };
    // 'premium' = alias historique d'Intensif (cf. dashboard-static PLAN_LABELS).
    case 'intensif':
    case 'premium':
      return { id: 'intensif', name: 'Intensif', price: 179, features: PLAN_FEATURES.intensif };
    default:
      return { id: null, name: 'Aucun plan', price: 0, features: [] };
  }
}
